import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import 'reset-css'

import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueSocialSharing from 'vue-social-sharing'

Vue.config.productionTip = false


import headingComp from '@/components/heading.vue'
Vue.component('headingComp', headingComp)

import interestPoint from '@/components/interest-point-item.vue'
Vue.component('interestPoint', interestPoint)

import calendarItem from '@/components/calendar-item.vue'
Vue.component('calendarItem', calendarItem)

import elvasButton from '@/components/elvas-button.vue'
Vue.component('elvasButton', elvasButton)

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueSocialSharing);

Vue.use(api)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
